import React, { useState, useEffect } from "react";
import Loader from "components/Loader";
import { useParams } from "react-router-dom";
import TimelineTodoListTasks from "components/TodoList/TimelineTodoTasks/TimelineTodoListTasks";
import TeamService from "services/TeamService";
import { TimelineContext } from "store/contexts/timelineContext";
import { useHistory } from "react-router-dom";
import { useGlobalContext } from "store/contexts/globalContext";
import { useTeamActionContext } from "store/contexts/teamActionContext";

const styles = {
  heading: {
    fontWeight: 400,
    display: "flex",
    justifyContent: "center",
    marginBottom: "0px",
    paddingTop: "30px",
  },
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
  },
};

export default () => {
  const classes = styles;
  const [list, setList] = useState([]);
  const { listId, taskId } = useParams();
  const { teamId } = useTeamActionContext();
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  let history = useHistory();
  const { ringCentral } = useGlobalContext();

  useEffect(() => {
    (async () => {
      try {
        const response = await TeamService.getSingleListItem(
          teamId,
          listId,
          taskId
        );
        setList([response?.data?.data]);
        setTotal(1);
        setLoading(false);
      } catch (e) {
        if (ringCentral) {
          history.push(`/ringCentral/teams/${teamId}/noPost/task`);
          return;
        }
        console.error(e);
        console.log(e.response);
      }
    })();

    //eslint-disable-next-line
  }, [teamId, listId, taskId]);

  const updateTask = (task) => {
    const timelineCopy = [...list];

    timelineCopy[
      timelineCopy.findIndex((tTask) => {
        return tTask.id === task.id;
      })
    ] = {
      ...task,
    };

    setList(timelineCopy);
  };

  const deleteTask = (task) => {
    setList(list.filter((timeline) => timeline.id !== task.id));
    history.push(`/teams/${teamId}/timeline`);
  };

  return (
    <TimelineContext.Provider
      value={{
        updateTask,
        deleteTask,
      }}
    >
      <div className="listRoot">
        <h3 style={classes.heading}>Your List Item</h3>
        {loading && (
          <div style={classes.loaderStyle}>
            <Loader />
          </div>
        )}
        <div>
          {!loading && <TimelineTodoListTasks listTasks={list} total={total} />}
        </div>
      </div>
    </TimelineContext.Provider>
  );
};
